import PropTypes from 'prop-types';
import { lazy, Suspense, useRef } from 'react';
import {
  BrowserRouter,
  Routes as ReactRouterRoutes,
  Route,
} from 'react-router-dom';

import TopicContext, {
  defaultValue as defaultValueTopicContext,
} from 'hb-react/frontoffice/contexts/TopicContext';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import ErrorBoundary from 'hb-react/shared/components/ErrorBoundary';

const TopicsAppClient = lazy(() => import('./TopicsAppClient'));

const TopicsAppStandalone = (props) => {
  const {
    network,
    networkLoginUrl,
    networkRootUrl,
    topicId,
    topicName,
    ...otherProps
  } = props;

  const topicMenuRef = useRef(null);

  return (
    <ErrorBoundary
      context={{
        tags: {
          module: 'topics_po',
        },
      }}
    >
      <PublicOfficeApp
        network={network}
        providers={[
          {
            provider: TopicContext.Provider,
            value: {
              networkLoginUrl,
              networkRootUrl,
              topicId,
              whitelabelURL: !!(
                defaultValueTopicContext.whitelabelURL && topicId
              ),
              whitelabelName: defaultValueTopicContext.whitelabelName,
              topicMenuRef,
              standalone: true,
              topicName,
            },
          },
        ]}
      >
        <BrowserRouter>
          <Suspense fallback={null}>
            <ReactRouterRoutes>
              <Route path="*" element={<TopicsAppClient {...otherProps} />} />
            </ReactRouterRoutes>
          </Suspense>
        </BrowserRouter>
      </PublicOfficeApp>
    </ErrorBoundary>
  );
};

TopicsAppStandalone.propTypes = {
  network: PropTypes.object.isRequired,
  topicId: PropTypes.number,
  networkLoginUrl: PropTypes.string,
  networkRootUrl: PropTypes.string,
};

export default TopicsAppStandalone;
